module.exports = __webpack_public_path__ + "static/media/check-icon.df886ffc.svg";